import { render, staticRenderFns } from "./TempRankingManagement.vue?vue&type=template&id=e1832c42&"
import script from "./TempRankingManagement.vue?vue&type=script&lang=js&"
export * from "./TempRankingManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports